import BulkPublishProvider from '@/modules/cms/views/post/components/builder/bulk-publish/Provider'

export default function AppFooter({ children }) {
  return <BulkPublishProvider>
    {children}
  </BulkPublishProvider>
}
